/* eslint-disable arrow-parens */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */
// import {popupRegistration} from '../main';
import IMask from 'imask';
import helpers from '../helpers';
import formAssessment from './formAssessment';

export class Form {
	constructor(form) {
		this.form = form;
		this.allBtnSubmit = this.form.querySelectorAll('.form__submit');
		this.allInput = this.form.querySelectorAll('input');
		this.formApproved = true;
		this.maxLink = 10;
		this.init();
		this.filesImg = [];
		this.filesDoc = [];
		this.maxImg = 10;
	}

	// eslint-disable-next-line
	createErrorMessage(formItem, errorMessage) {
		if (!formItem.querySelector('.error-message')) {
			const errorMessageDiv = document.createElement('div');
			errorMessageDiv.classList.add('error-message');
			errorMessageDiv.innerHTML = errorMessage;
			formItem.append(errorMessageDiv);
		}
	}

	// eslint-disable-next-line
	removeErrorMessage(formItem) {
		const errorMessage = formItem.querySelector('.error-message');

		if (errorMessage) {
			errorMessage.remove();
		}
	}

	setInvalidClass(input, errorMessage) {
		const parent = input.closest('.form__item');

		if (input.classList.contains('invalid')) {
			parent.classList.add('is-invalid');
			this.createErrorMessage(parent, errorMessage);
			input.classList.remove('approve');
		} else {
			parent.classList.remove('is-invalid');
			this.removeErrorMessage(parent);
			input.classList.add('approve');
		}
	}

	checkRadioBtn(input, errorMessage) {
		const parent = input.closest('.form__item');
		const name = input.name;
		let checked = false;

		this.form.querySelectorAll(`[name="${name}"]`).forEach((el) => {
			if (el.checked) {
				checked = true;
			}
		});

		if (!checked) {
			parent.classList.add('is-invalid');
			this.createErrorMessage(parent, errorMessage);
		} else {
			this.removeErrorMessage(parent);
			parent.classList.remove('is-invalid');
		}
	}

	checkTelforFormProject(e) {
		const inputTel = document.getElementById('contacts').querySelector('#tel');
		this.checkTel(inputTel);

		if (inputTel.classList.contains('invalid')) {
			e.target.disabled = true;
			this.formApproved = false;
			helpers.scrollTo($(inputTel), 500, -200);
		}
	}

	checkTel(input) {
		if (input.value.length > 0 && input.value.length < 17) {
			input.classList.add('invalid');
			this.removeErrorMessage(input.closest('.form__item'));
			this.setInvalidClass(input, 'Введите корректный номер');
		} else if (input.value.length === 0) {
			input.classList.add('invalid');
			this.removeErrorMessage(input.closest('.form__item'));
			this.setInvalidClass(input, 'Введите номер');
		} else {
			input.classList.remove('invalid');
			this.setInvalidClass(input);

			const allProjectForms = document.querySelectorAll('.project-form');
			if (allProjectForms.length !== 0) {
				allProjectForms.forEach((form) => {
					const btnSendForm = form.querySelector('.send-form');
					if (btnSendForm) {
						btnSendForm.disabled = false;
					}
				});
			}
		}
	}

	checkEmail(input) {
		const checkedValue = String(input.value)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			);

		if (input.value.length === 0) {
			input.classList.add('invalid');
			this.removeErrorMessage(input.closest('.form__item'));
			this.setInvalidClass(input, 'Укажите email');
		} else if (!checkedValue) {
			input.classList.add('invalid');
			this.removeErrorMessage(input.closest('.form__item'));
			this.setInvalidClass(input, 'Укажите корректный email');
		} else {
			input.classList.remove('invalid');
			this.setInvalidClass(input);
		}
	}

	checkPassword(input) {
		const parent = input.closest('.form');
		const repeatPassword = parent.querySelector('#password');

		if (input.id === 'repeat-password') {
			if (input.value !== repeatPassword.value) {
				input.classList.add('invalid');
				this.setInvalidClass(input, 'Пароли не совпадают');
			} else {
				input.classList.remove('invalid');
				this.setInvalidClass(input);
			}
		} else if (input.value.length === 0) {
			input.classList.add('invalid');
			this.setInvalidClass(input, 'Заполните поле');
		} else {
			input.classList.remove('invalid');
			this.setInvalidClass(input);
		}
	}

	validation(input) {
		switch (input.type) {
			case 'text':
				if (input.value.length === 0) {
					input.classList.add('invalid');
					this.setInvalidClass(input, 'Заполните поле');
				} else {
					input.classList.remove('invalid');
					this.setInvalidClass(input);
				}
				break;
			case 'radio':
				this.checkRadioBtn(input, 'Выберите номинацию');
				break;
			case 'tel':
				this.checkTel(input);
				break;
			case 'email':
				this.checkEmail(input);
				break;
			case 'password':
				this.checkPassword(input);
				break;
			default: break;
		}
	}

	checkForm() {
		let approve = true;
		let requareInput = 0;
		let approveInput = 0;
		this.allInput.forEach((el) => {
			if (el.required) {
				requareInput++;
			}
			if (el.classList.contains('approve')) {
				approveInput++;
			}
		});

		if (requareInput !== approveInput) {
			approve = false;
		}

		this.formApproved = approve;

		if (this.formApproved) {
			// eslint-disable-next-line arrow-parens
			this.allBtnSubmit.forEach(el => {
				el.disabled = false;

				if (el.classList.contains('send-form')) {
					if (!this.form.querySelector('#send-project').checked) {
						el.disabled = true;
					}
				}
			});
		} else {
			// eslint-disable-next-line arrow-parens
			this.allBtnSubmit.forEach(el => el.disabled = true);
		}
	}

	// eslint-disable-next-line
	removeInput(e) {
		const itemGroup = e.target.closest('.form__item--group');
		const btnAdd = itemGroup.querySelector('.form__btn-add');
		const parent = e.target.closest('.form__item');
		parent.remove();

		if (itemGroup.querySelectorAll('input').length <= 10) {
			btnAdd.style.display = 'flex';
		}
	}

	addInput(e) {
		const parent = e.target.closest('.form__item');
		const allInput = parent.querySelectorAll('input').length ? parent.querySelectorAll('input').length : 0;
		let newInputHtml;

		if (parent.classList.contains('download-video')) {
			newInputHtml = `<input class="form__input" type="text" name="link-video" placeholder="К примеру, https://www.youtube.com/watch?v=Ltb8wxR4MDY">
						<div class="form__btn-remove"></div>`;
		}
		if (parent.classList.contains('download-smi')) {
			newInputHtml = `<input class="form__input" type="text" name="link-smi" placeholder="К примеру, https://www.kp.ru/Ltb8wxR4MDY">
							<div class="form__btn-remove"></div>`;
		}
		if (allInput < this.maxLink) {
			const newInput = document.createElement('div');
			newInput.classList.add('form__item');
			newInput.innerHTML = newInputHtml;
			parent.append(newInput);
		} else if (allInput === this.maxLink) {
			parent.querySelector('.form__btn-add').style.display = 'none';
		}
	}

	saccsessMesage(btn) {
		// const link = this.form.querySelector('#nomination').value;
		const formBotton = btn.closest('.form__bottom-project-send');
		const message = `<div class="popup-registration__success">
			<div class="popup-registration__success-icon">
				<svg>
					<use xlink:href="/images/sprites.svg#icon-check-white"></use>
				</svg>
				</div>Проект опубликован<span>Поздравляем! Ваша заявка отправлена на&nbsp;рассмотрение экспертному совету. Если Вы&nbsp;хотите подать еще одну заявку ознакомьтесь с&nbsp;другими номинациями конкурса</span>
				<a class="btn btn--oval btn--green" href="/nominatsii">Посмотреть номинации</a>
			</div>`;
		formBotton.innerHTML = '';
		formBotton.innerHTML = message;

		this.form.classList.add('form--published');
	}

	submit(e) {
		if (e.target.classList.contains('send-form')) {
			this.checkTelforFormProject(e);

			if (!this.formApproved) {
				return;
			}
		}

		// отчистка инпутов файлов перед отправкой
		if (this.form.querySelector('.download-img-input')) {
			this.form.querySelector('.download-img-input').value = '';
		}

		if (this.form.querySelector('.download-doc-input')) {
			this.form.querySelector('.download-doc-input').value = '';
		}

		const url = '/ajax/form.php';
		const data = new URLSearchParams();
		const formData = new FormData(this.form);

		// добавление файлов изображений
		if (this.filesImg.length !== 0) {
			this.filesImg.forEach((file) => {
				formData.append('img', file);
			});
		}

		// добавление файлов документов
		if (this.filesDoc.length !== 0) {
			this.filesDoc.forEach((file) => {
				formData.append('doc', file);
			});
		}

		for (const pair of formData) {
			data.append(pair[0], pair[1]);
		}

		fetch(url, {
			method: 'post',
			body: data,
		}).then((response) => {
			if (response.status < 200 || response.status > 300) {
				let error = new Error(response.statusText);
				error.response = response;
				throw error;
			} else {
				if (this.form.id === 'registration') {
					// popupRegistration.formSuccsess();
					if (!document.querySelector('.lichnyj-kabinet')) {
						ga('send', 'event', 'award', 'send request success');
					}
				}

				if (this.form.id === 'assessment-form') {
					formAssessment.formSuccsess(this.form);
				}

				if (e.target.classList.contains('send-form')) {
					this.saccsessMesage(e.target);
				}

				return response;
			}
		});
	}

	inputImgChangeHandler(event) {
		if (!event.target.files.length) {
			return;
		}

		this.filesImg = Array.from(event.target.files);
		const fileInputContainer = event.target.closest('.download-img');
		const fileInputBtn = fileInputContainer.querySelector('.form__btn-add');

		fileInputContainer.querySelectorAll('.form__previe-img').forEach(el => {
			el.remove();
		});

		// eslint-disable-next-line arrow-parens
		this.filesImg.forEach((file, index) => {
			if (!file.type.match('image')) {
				return;
			}

			if (index < this.maxImg) {
				const reader = new FileReader();
				reader.onload = e => {
					const src = e.target.result;
					fileInputContainer.insertAdjacentHTML('afterbegin', `
						<div class="form__previe-img">
							<button class="form__btn-remove img-remove-js" type="button" data-type="img" data-name="${file.name}"></button>
							<img src="${src}" alt="${file.name}">
						</div>
					`);
				};

				reader.readAsDataURL(file);
				fileInputBtn.classList.add('small');
			}
		});
	}

	inputDocChangeHandler(event) {
		if (!event.target.files.length) {
			return;
		}

		this.filesDoc = Array.from(event.target.files);
		const fileInputContainer = event.target.closest('.download-doc');

		fileInputContainer.querySelectorAll('.form__previe-doc').forEach(el => {
			el.remove();
		});

		// eslint-disable-next-line arrow-parens
		this.filesDoc.forEach(file => {
			if (!file.type.match('application')) {
				return;
			}

			fileInputContainer.insertAdjacentHTML('afterbegin', `
				<div class="form__previe-doc">
					${file.name}
					<button class="form__btn-remove img-remove-js" type="button" data-type="doc" data-name="${file.name}"></button>
				</div>
            `);
		});
	}

	removeHandler(event) {
		const {name} = event.target.dataset;
		const fileInputContainer = event.target.closest(`.download-${event.target.dataset.type}`);
		const fileInputBtn = fileInputContainer.querySelector('.form__btn-add');

		if (name) {
			if (event.target.dataset.type === 'img') {
				this.filesImg = this.filesImg.filter(f => f.name !== name);

				if (!this.filesImg.length) {
					fileInputBtn.classList.remove('small');
				}
			} else if (event.target.dataset.type === 'doc') {
				this.filesDoc = this.filesDoc.filter(f => f.name !== name);
			}

			const block = fileInputContainer.querySelector(`[data-name="${name}"]`).closest(`.form__previe-${event.target.dataset.type}`);
			block.remove();
		}

		this.form.querySelector(`.download-${event.target.dataset.type}-input`).value = '';
	}

	init() {
		this.allInput.forEach((element) => {
			if (element.type === 'tel') {
				// eslint-disable-next-line
				IMask(element, {
					mask: '+7(000)-000-00-00',
				});
			}
			element.addEventListener('blur', (e) => {
				if (e.target.required) {
					this.validation(e.target);
				}
			});
		});

		this.allInput.forEach((element) => {
			element.addEventListener('change', (e) => {
				if (e.target.required) {
					this.validation(e.target);
					this.checkForm();
				}
			});
		});

		this.form.querySelectorAll('.add-input-js').forEach((el) => {
			el.addEventListener('click', (e) => {
				this.addInput(e);
			});
		});

		this.form.addEventListener('click', (e) => {
			if (e.target.classList.contains('form__btn-remove') && !e.target.classList.contains('img-remove-js')) {
				this.removeInput(e);
			}

			if (e.target.type === 'submit') {
				if (e.target.id !== 'enter-submit') {
					e.preventDefault();
					this.checkForm();

					if (this.formApproved) {
						this.submit(e);
					}
				} else {
					e.preventDefault();
					this.submit(e);
				}
			}

			if (e.target.classList.contains('img-remove-js')) {
				this.removeHandler(e);
			}
		});

		if (this.form.querySelector('#send-project')) {
			this.form.querySelector('#send-project').addEventListener('change', this.checkForm.bind(this));
		}

		if (this.form.querySelector('.download-img-input')) {
			this.form.querySelector('.download-img-input').addEventListener('change', (e) => {
				this.inputImgChangeHandler(e);
			});
		}

		if (this.form.querySelector('.download-doc-input')) {
			this.form.querySelector('.download-doc-input').addEventListener('change', (e) => {
				this.inputDocChangeHandler(e);
			});
		}
	}
}

function init() {
	document.querySelectorAll('form').forEach((el) => {
		if (!el.classList.contains('new-form')) {
			// eslint-disable-next-line
			new Form(el);
		}
	});
}

export default {
	init,
};
